import { useNavigate } from 'react-router-dom';
import { Container, Grid } from '@mui/material';
import logo from '../../assets/images/header/Logo.svg';
import './styles.scss';

export default function AgotoIntento() {
  const navigate = useNavigate();

  let backgroundStyles = '';
  backgroundStyles += `#root::after {background-color: #fff }`;
  return (
    <>
      <style>{backgroundStyles}</style>
      <div id='agotoIntento'>
        <div className='header'>
          <img src={logo} alt='logo' />
        </div>
        <Container maxWidth='lg' style={{ marginTop: '21%' }}>
          <Grid container justifyContent='center' alignItems='center' spacing={4}>
            <Grid item xs={12} sm={7} md={7} lg={7}>
              <h1>Ya agotaste tus intentos</h1>
              <p>
                Lo sentimos, pero has alcanzado el número máximo de intentos permitidos.
                <br /> Por favor, contacta con el equipo para más información.
              </p>
            </Grid>
            <Grid item xs={12} sm={7} md={7} lg={7}>
              <div className='btn-iniciar' onClick={() => navigate('/')}>
                Regresar
              </div>
            </Grid>
          </Grid>
        </Container>
      </div>
    </>
  );
}
